// extracted by mini-css-extract-plugin
export default {"TestMockFooter":"TestMockFooter_TestMockFooter__TD3rG"};